import React from 'react';
import { Sheet } from 'tamagui';
import { Button, useTheme } from 'tamagui';

import {
  CobuContainer,
  CobuStack,
  CobuText,
  CobuButton,
} from '@cobu/ui';
import { Strings } from '../../constants';
import { analyticsService, AnalyticsEvent } from '@cobu/analytics';
import { showErrorMessage } from '../../utils/messageToast';

const strings = Strings.get();

interface GoogleReviewModalProps {
  visible: boolean;
  onClose: () => void;
  reviewUrl: string;
  buildingName: string;
  onUpdateLastReviewed: () => void;
}

export default function GoogleReviewModal({
  visible,
  onClose,
  reviewUrl,
  buildingName,
  onUpdateLastReviewed,
}: GoogleReviewModalProps) {
  const theme = useTheme();
//   React.useEffect(() => {
//     if (visible) {
//       analyticsService.trackEvent(AnalyticsEvent.SHOW_GOOGLE_REVIEW_MODAL);
//     }
//   }, [visible]);

  const handleReviewPress = async () => {
    try {
      /* ANALYTICS_DISABLED: GOOGLE_REVIEW_CLICKED ('google_review_clicked')
        analyticsService.trackEvent(AnalyticsEvent.GOOGLE_REVIEW_CLICKED);
        */
      const win = window.open(reviewUrl, '_blank', 'noopener,noreferrer');
      if (win) {
        onUpdateLastReviewed();
        onClose();
      } else {
        showErrorMessage(`${strings.ui.googleReviewModal.errors.title}: ${strings.ui.googleReviewModal.errors.unableToOpenLink}`);
      }
    } catch (error) {
      showErrorMessage(`${strings.ui.googleReviewModal.errors.title}: ${strings.ui.googleReviewModal.errors.unableToOpenLink}`);
    }
  };

  const handleSkip = () => {
    /* ANALYTICS_DISABLED: GOOGLE_REVIEW_SKIPPED ('google_review_skipped')
      analyticsService.trackEvent(AnalyticsEvent.GOOGLE_REVIEW_SKIPPED);
      */
    onClose();
  };

  return (
    <Sheet modal open={visible} onOpenChange={onClose}>
      <Sheet.Overlay />
      <Sheet.Frame>
        <CobuContainer f={1} bg="$cobuDarkBlue">
          <CobuStack f={1} jc="center" px="$5" py="$6" gap="$6">
            <CobuStack ai="center" gap="$4" f={1} jc="center">
            <CobuText variant="heading" fos="$7" fow="bold" ta="center" col="$white">
              {strings.ui.googleReviewModal.title}
            </CobuText>
            
            <CobuText variant="body" fos="$4" ta="center" col="$white" lh="$4" px="$2">
              {strings.ui.googleReviewModal.description.replace('{buildingName}', buildingName)}
            </CobuText>

            <CobuButton
              title={strings.ui.googleReviewModal.buttons.writeReview}
              dsVariant="primary"
              onPress={handleReviewPress}
              w="100%"
              mt="$4"
              h="$14"
            />
            </CobuStack>

            <CobuStack w="100%" ai="center">
              <Button
                backgroundColor="white"
                onPress={handleSkip}
                height="$10"
                marginVertical="$4"
                paddingHorizontal="$6"
                borderRadius={0}
              >
                <CobuText col="$cobuDarkBlue" fos="$2" fow="500" ta="center">
                  {strings.ui.googleReviewModal.buttons.skip}
                </CobuText>
              </Button>
            </CobuStack>
          </CobuStack>
        </CobuContainer>
      </Sheet.Frame>
    </Sheet>
  );
}